import React from 'react';
import {
  Text,
} from 'react-native';
import { ScrollView } from 'react-native-gesture-handler';
import {
  getSubCategoryId,
} from '../../../../../utils/DictionaryManagementUtils';
import { getRegularFont } from '../../../../../utils/Utils';
import SearchContact from '../../../../ContactList/SearchContact';
import FullPageSimulator from '../../FullPageSimulator';

//= ========================================================================

const AccountManuallyFP = ({
  globJSON,
  selectedScreen,
  simPlatform,
  slideshowRefs = null,
  listName,
  withCloseIcon, inputText, TopTitle, withExtraHeightForTitle,
}) => {
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const { colors } = globJSON.configurations.theme;
  const renderListName = () => listName.map((item) => (
    <Text style={{
      paddingVertical: 5,
      paddingStart: 20,
      fontFamily: `${getRegularFont(globJSON, simPlatform)}`,
      fontSize: 9.3,
      color: colors.primary_font_color,
      textAlign: 'left',
    }}
    >
      {item}
    </Text>
  ));

  return (
    <FullPageSimulator
      globJSON={globJSON}
      simPlatform={simPlatform}
      keyboardType="lettersKeyboard"
      TopTitle={TopTitle}
      hideIcons
      withExtraHeightForTitle={withExtraHeightForTitle}
      slideshowRefs={slideshowRefs}
    >
      <SearchContact
        globJSON={globJSON}
        simPlatform={simPlatform}
        subCategoryId={subCategoryId}
        inputText={inputText}
        withCloseIcon={withCloseIcon}
        marginTop={3}
      />
      <ScrollView
        vertical
        pagingEnabled={false}
        showsVerticalScrollIndicator={false}
        scrollEnabled
      >
        {renderListName()}
      </ScrollView>
    </FullPageSimulator>
  );
};

export default AccountManuallyFP;
